/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';
//在途库存
export function transportationList(param) {
  return request(`${config.server}/api/v1/dms/transportation/list`, {
    method: 'post',
    body: param,
  });
}

export const exportFun = `${config.server}/api/v1/dms/transportation/exportTransport`;


// WEBPACK FOOTER //
// ./src/service/inventory/notReaching.js